import { type RoomPricesPartitions } from '@/types/benefits/hotel/HotelRoomPricingFormData';

export type RoomTypeFlags = Partial<
  Record<keyof RoomPricesPartitions, boolean>
>;

const ROOM_TYPE_KEYS: Array<keyof RoomPricesPartitions> = [
  'individual',
  'double',
  'triple',
  'quadruple',
];

/**
 * Price lines only make sense for the room types ticked on the category.
 * Lines left on an unticked type are required by the schema and block the
 * publication, so they are emptied here.
 */
export const pruneUncheckedRoomTypePartitions = <
  P extends RoomPricesPartitions,
>(
  pricePartitions: P,
  roomTypes: RoomTypeFlags,
): P => {
  if (!hasUncheckedRoomTypePartitions(pricePartitions, roomTypes))
    return pricePartitions;
  const pruned = { ...pricePartitions };
  for (const key of ROOM_TYPE_KEYS) if (!roomTypes[key]) pruned[key] = [];
  return pruned;
};

export const hasUncheckedRoomTypePartitions = (
  pricePartitions: RoomPricesPartitions | undefined,
  roomTypes: RoomTypeFlags,
) =>
  ROOM_TYPE_KEYS.some(
    (key) => !roomTypes[key] && (pricePartitions?.[key]?.length ?? 0) > 0,
  );
